
import { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import VDCcomboLogo from '../assets/images/Logos.png'

export default function Topbar({ onToggleSidebar }) {
     const [showUserDropdown, setShowUserDropdown] = useState(false);
     const { user, logout } = useAuth();

     // Use actual user data from auth context
     const currentUser = user || {
          name: "Guest User",
          email: "guest@vdc.com",
          role: "Guest",
          avatar: null
     };

     const handleLogout = () => {
          logout();
          setShowUserDropdown(false);
     };

     const toggleUserDropdown = () => {
          setShowUserDropdown(!showUserDropdown);
     };

     // Close dropdown when clicking outside
     const handleClickOutside = (e) => {
          if (!e.target.closest('.user-dropdown')) {
               setShowUserDropdown(false);
          }
     };

     // Add event listener for clicking outside
     if (typeof document !== 'undefined') {
          document.addEventListener('click', handleClickOutside);
     }

     return (
          <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
               <button
                    id="sidebarToggleTop"
                    className="btn btn-link rounded-circle mr-3"
                    onClick={onToggleSidebar}
                    style={{ display: 'block' }} // Always show the toggle button
               >
                    <i className="fa fa-bars"></i>
               </button>

               <h5 className="ml-3 mb-0">Dashboard</h5>

               {/* Spacer to push items to the right */}
               <div className="ml-auto d-flex align-items-center">
                    <img src={VDCcomboLogo} alt="VDC Logo" style={{ height: '60px' }} className="mr-3" />

                    {/* User Dropdown */}
                    <div className="nav-item dropdown no-arrow user-dropdown" style={{ position: 'relative' }}>
                         <div
                              className="nav-link dropdown-toggle d-flex align-items-center"
                              style={{ cursor: 'pointer', padding: '0.5rem 1rem', borderRadius: '0.35rem' }}
                              onClick={toggleUserDropdown}
                              onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fc'}
                              onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                         >
                              {/* User Avatar or Icon */}
                              <div
                                   className="d-flex align-items-center justify-content-center mr-2"
                                   style={{
                                        width: '32px',
                                        height: '32px',
                                        backgroundColor: '#4e73df',
                                        borderRadius: '50%',
                                        color: 'white',
                                        fontSize: '14px',
                                        fontWeight: 'bold'
                                   }}
                              >
                                   {currentUser.avatar ? (
                                        <img
                                             src={currentUser.avatar}
                                             alt="User Avatar"
                                             style={{ width: '100%', height: '100%', borderRadius: '50%' }}
                                        />
                                   ) : (
                                        <span>{currentUser.name.split(' ').map(n => n[0]).join('')}</span>
                                   )}
                              </div>

                              {/* User Name */}
                              <span className="mr-2 d-none d-lg-inline text-gray-600 small" style={{ fontWeight: '600' }}>
                                   {currentUser.name}
                              </span>

                              {/* Dropdown Arrow */}
                              <i className="fas fa-caret-down"></i>
                         </div>

                         {/* Dropdown Menu */}
                         {showUserDropdown && (
                              <div
                                   className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
                                   style={{
                                        position: 'absolute',
                                        top: '100%',
                                        right: '0',
                                        display: 'block',
                                        minWidth: '280px',
                                        backgroundColor: 'white',
                                        border: '1px solid #e3e6f0',
                                        borderRadius: '0.35rem',
                                        boxShadow: '0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15)',
                                        zIndex: 1000
                                   }}
                              >
                                   {/* User Info Header */}
                                   <div className="px-4 py-3" style={{ borderBottom: '1px solid #e3e6f0' }}>
                                        <div className="d-flex align-items-center">
                                             <div
                                                  className="d-flex align-items-center justify-content-center mr-3"
                                                  style={{
                                                       width: '48px',
                                                       height: '48px',
                                                       backgroundColor: '#4e73df',
                                                       borderRadius: '50%',
                                                       color: 'white',
                                                       fontSize: '18px',
                                                       fontWeight: 'bold'
                                                  }}
                                             >
                                                  {currentUser.avatar ? (
                                                       <img
                                                            src={currentUser.avatar}
                                                            alt="User Avatar"
                                                            style={{ width: '100%', height: '100%', borderRadius: '50%' }}
                                                       />
                                                  ) : (
                                                       <span>{currentUser.name.split(' ').map(n => n[0]).join('')}</span>
                                                  )}
                                             </div>
                                             <div>
                                                  <div className="font-weight-bold" style={{ fontSize: '0.9rem', color: '#5a5c69' }}>
                                                       {currentUser.name}
                                                  </div>
                                                  <div className="small text-muted">{currentUser.email}</div>
                                                  <div className="small text-muted">{currentUser.role}</div>
                                             </div>
                                        </div>
                                   </div>

                                   {/* Menu Items */}
                                   <div className="py-1">
                                        <button
                                             className="dropdown-item d-flex align-items-center"
                                             style={{
                                                  border: 'none',
                                                  background: 'none',
                                                  width: '100%',
                                                  padding: '0.5rem 1.5rem',
                                                  textAlign: 'left',
                                                  fontSize: '0.875rem'
                                             }}
                                             onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fc'}
                                             onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                                        >
                                             <i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
                                             Profile
                                        </button>

                                        <button
                                             className="dropdown-item d-flex align-items-center"
                                             style={{
                                                  border: 'none',
                                                  background: 'none',
                                                  width: '100%',
                                                  padding: '0.5rem 1.5rem',
                                                  textAlign: 'left',
                                                  fontSize: '0.875rem'
                                             }}
                                             onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fc'}
                                             onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                                        >
                                             <i className="fas fa-cogs fa-sm fa-fw mr-2 text-gray-400"></i>
                                             Settings
                                        </button>

                                        <div className="dropdown-divider" style={{ margin: '0.5rem 0', borderTop: '1px solid #e3e6f0' }}></div>

                                        <button
                                             className="dropdown-item d-flex align-items-center"
                                             onClick={handleLogout}
                                             style={{
                                                  border: 'none',
                                                  background: 'none',
                                                  width: '100%',
                                                  padding: '0.5rem 1.5rem',
                                                  textAlign: 'left',
                                                  fontSize: '0.875rem',
                                                  color: '#e74a3b'
                                             }}
                                             onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fc'}
                                             onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                                        >
                                             <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2"></i>
                                             Logout
                                        </button>
                                   </div>
                              </div>
                         )}
                    </div>
               </div>
          </nav>
     );
}
